import { types } from '../types'

const initialState = {
    waiting: false,
    success: false,
    error: '',

    addWaiting: false,
    addSuccess: false,
    addError: false,

    updateWaiting: false,
    updateSuccess: false,
    updateError: false,

    roleWaiting: false,
    roleSuccess: false,
    roleError: false,


    userList: {},
    roleList: [],
    displayToast: false,
}

const accessibilityReducer = (state = initialState, { type, action }) => {
    switch (type) {
        case types.GET_ADMIN_USER_REQUEST: {
            return {
                ...state,
                waiting: true,
                success: false,
                userList: {}
            }
        }
        case types.GET_ADMIN_USER_SUCCESS: {
            return {
                ...state,
                waiting: false,
                success: true,
                userList: action.data,
            }
        }
        case types.GET_ADMIN_USER__ERROR: {
            return {
                ...state,
                waiting: false,
                error: action.error,
            }
        }






        case types.ADD_ADMIN_USER_REQUEST: {
            return {
                ...state,
                addWaiting: true,
                addSuccess: false,
            }
        }
        case types.ADD_ADMIN_USER_SUCCESS: {

            return {
                ...state,
                addWaiting: false,
                addSuccess: true,
                userList: action.data.data,
                // displayToast: "vvvvv"

            }
        }
        case types.ADD_ADMIN_USER__ERROR: {
            return {
                ...state,
                addWaiting: false,
                addError: action.error,
            }
        }





        case types.UPDATE_ADMIN_USER_REQUEST: {
            return {
                ...state,
                updateWaiting: true,
                updateSuccess: false,
            }
        }
        case types.UPDATE_ADMIN_USER_SUCCESS: {

            return {
                ...state,
                updateWaiting: false,
                updateSuccess: true,
                userList: action.data.data,
            }
        }
        case types.UPDATE_ADMIN_USER__ERROR: {
            return {
                ...state,
                updateWaiting: false,
                updateError: action.error,
            }
        }



        case types.GET_ALL_ROLES_REQUEST: {
            return {
                ...state,
                roleWaiting: true,
                roleSuccess: false,
            }
        }
        case types.GET_ALL_ROLES_SUCCESS: {
            return {
                ...state,
                roleWaiting: false,
                roleSuccess: true,
                roleList: action.data,
            }
        }
        case types.GET_ALL_ROLES_ERROR: {
            return {
                ...state,
                roleWaiting: false,
                roleError: action.error,
            }
        }




        case types.ACCESSIBILITY_RESET_PROPS: {
            return {
                ...state,
                waiting: false,
                success: false,
                error: '',

                addWaiting: false,
                addSuccess: false,
                addError: false,

                updateWaiting: false,
                updateSuccess: false,
                updateError: false,

                roleWaiting: false,
                roleSuccess: false,
                roleError: false,


                userList: {},
                roleList: []
            }
        }
        default:
            return state
    }
}

export default accessibilityReducer;